import Router from "@/src/components/router";

export default function Index() {
  return (
    <Router
      routes={[
        {
          text: "Pre-pidgey - Changes to transaction details",
          componentUrl:
            "/(auth)/merchant/transaction-details/consumer-delivery-actions",
          notionUrl:
            "https://www.notion.so/cuanto/Implement-Pre-pidgey-changes-to-Consumer-Card-c4ce8af9dd5340be8dcf93517bdfbf65?pvs=4",
        },
        { text: "Merchant", componentUrl: "/(auth)/merchant" },
      ]}
    />
  );
}
